(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[682],{

/***/ "7dhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Needle", function() { return Needle; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Needle = function Needle(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 174 500"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M173.9 250.2v1.6l-.1.8-.2 1.5-.5 3-.6 3.5-.8 4-1.6 7-1.9 7.9-3 12-5.4 20.2-8.2 30-7.9 27.6-7.8 27.2-23.5 79.1c-5.7 13.8-12.3 21.2-20 23.6l-1.4.4-1.8.3-1.7.1h-2.1l-1.5-.2c-8.2-1-15-6.9-20.6-19.6l-1-2.4-1-2.9-4.7-15.4-12.7-43.4-16.2-57-7-25-5.4-19.8-4-14.8-4.4-16.6-2.8-11.4-1.7-7.3-.9-4-.7-3.7-.5-2.8L0 251v-2.5l.2-.9.3-2.4.6-3 1.1-5.5 2.2-9 2-8 4-15.4 5.6-21 7.3-26.7L36.8 109 61 25C65.6 11.7 71.3 4.4 78.5 1.4L80 .9l1.7-.5 1.1-.2 1.6-.1L86 0h2l1.6.1c8.5 1 16 7.2 21.3 20.2l1 2.5.9 2.6 26.4 90 11.3 39.3 8.4 30.4 4.7 17.5 3.3 12.6 2 8.6 2.4 10 1.3 6.2.7 3.4.2 1.7.4 2.7.1 2.4Zm-10.2-.2v-1l-.5-2.8-.7-4.1-1.3-6-2.2-9.7-2.1-8.5-3.3-12.5L149 188l-8.5-30.3-11.2-39.3-26.4-89.7-.7-2.2C98.4 16.2 94 12 89.4 11l-1-.2h-3.1l-1.2.1-1.3.3c-3.9 1.3-7.6 5.6-11.2 15l-.7 2.2-24.2 83.9-13.4 47.4-7.4 26.8-5.6 20.8-4 15.3-2 7.9-2 8.8-1.1 5.3-.5 2.6-.3 2v1h25.5A52.2 52.2 0 0 0 87 303.4a52.2 52.2 0 0 0 51.2-53.2l16.4-.1h9.2Z"
  }), __jsx("circle", {
    cx: "87",
    cy: "250",
    r: "40"
  }));
};

/***/ })

}]);